import { Component, OnInit, Inject } from '@angular/core';
import { HistoryProvider } from '../../core/browser-providers';
import { NavigationService } from '../../shared-services/navigation.service';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {
  constructor(
    @Inject(HistoryProvider) private history: History,
    private navigationService: NavigationService,
  ) {}

  back() {
    this.navigationService.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/back-button/back-button.component.ts